export const SHOW_STRIPE_PAYMENT_MODAL = 'SHOW_STRIPE_PAYMENT_MODAL'
export const SHOW_CONFIRMED_ADMINS_ADD_MODAL = 'SHOW_CONFIRMED_ADMINS_ADD_MODAL'
export const SHOW_CONFIRMED_ADMINS_EDIT_MODAL = 'SHOW_CONFIRMED_ADMINS_EDIT_MODAL'
export const SHOW_ADMINS_DETAIL_MODAL = 'SHOW_ADMINS_DETAIL_MODAL'
export const SHOW_CONFIRMED_CREATE_PAYMENT_MODAL = 'SHOW_CONFIRMED_CREATE_PAYMENT_MODAL'
export const SHOW_DETAIL_PAYMENT_MODAL = 'SHOW_DETAIL_PAYMENT_MODAL'
export const HIDE_MODAL = 'HIDE_MODAL'
export const SHOW_CONFIRMED_ARTICLES_ADD_MODAL = 'SHOW_CONFIRMED_ARTICLES_ADD_MODAL'
export const SHOW_CATEGORIES_ADD_MODAL = 'SHOW_CATEGORIES_ADD_MODAL'
